export default __webpack_public_path__ + "static/media/home-screen.6e3416d7.svg";